import { useState } from "react";
import { Logo } from "./ui/Logo";
import { DesktopNavigation } from "./navigation/DesktopNavigation";
import { MobileMenuButton } from "./navigation/MobileMenuButton";
import { MobileMenu } from "./navigation/MobileMenu";
import { menuItems } from "../data/menuItems";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="flex justify-center bg-gradient-to-b from-(--darkdarkred) to-(--darkred) to-45%">
      <nav
        className="container flex items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <Logo />

        <MobileMenuButton onClick={() => setMobileMenuOpen(true)} />

        <DesktopNavigation menuItems={menuItems} />

        <MobileMenu
          isOpen={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          menuItems={menuItems}
        />
      </nav>
    </header>
  );
}